module.exports = __webpack_public_path__ + "static/media/login.8ad3d406.png";